import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Language_i18 from '../../js/useNationalLanguage.jsx';

const Admin_home = () => {
  const { lang } = Language_i18();

  const [json_data, set_json_data] = useState('');
  const time_update = 15 * 60 * 1000; // 15 phút

  // Nhãn song ngữ, bao gồm cả đơn vị
  const labels = {
    users_total: {
      vi: '👪 Số thành viên gia đình ❤️',
      en: '👪 Total family members ❤️'
    },
    orders_total: {
      vi: '👑 Tổng đơn đã hoàn thành 💌',
      en: '👑 Total completed orders 💌'
    },
    orders_unit: {
      vi: 'đơn',
      en: 'orders'
    },
    total_nap_sum: {
      vi: '🎁 Số coins healing tặng users ✨',
      en: '🎁 Healing coins gifted to users ✨'
    },
    nap_unit: {
      vi: 'coins',
      en: 'coins'
    },
    count_orders_today: {
      vi: '🥤 Tổng đơn hôm nay ✨',
      en: '🥤 Total orders today ✨'
    },
    cup_unit: {
      vi: 'đơn',
      en: 'orders'
    },
    footer: {
      vi: 'cập nhật sau 10 phút',
      en: 'updates every 10 minutes'
    }
  };

  // Fetch & cache
  function laydulieu() {
    axios
      .get('https://hust.media/api/profile/statistic.php')
      .then(response => {
        const store = {
          timestamp: Date.now(),
          data: response.data
        };
        localStorage.setItem('profile_statistic', JSON.stringify(store));
        set_json_data(response.data);
      })
      .catch(error => console.log(error));
  }

  useEffect(() => {
    const raw = localStorage.getItem('profile_statistic');
    const store = raw ? JSON.parse(raw) : null;
    const expired = !store || (Date.now() - store.timestamp > time_update);

    if (!expired) {
      set_json_data(store.data);
      console.log('Loaded profile statistics from cache.');
    } else {
      localStorage.removeItem('profile_statistic');
      console.log('Cache expired/missing for profile statistics, fetching new data.');
      laydulieu();
    }
  }, []);

  const formatNumber = (number) =>
    number != null ? number.toLocaleString('en-GB') : '0';

  return (
    <>
      {json_data && (
        <>
          <div className="max-w-4xl mx-auto">
            <div className="mt-1 grid grid-cols-1">
              <div className="mb-1 bg-purple-100 bg-opacity-50 rounded-md shadow-md md:col-span-2">
                <div className="mt-2 px-2">
                  <div className="grid grid-cols-2 gap-4 mb-2">
                    <div className="bg-green-100 bg-opacity-50 rounded-md shadow-md border-1 border-purple-300">
                      <div className="text-base items-center">
                        <div className="ml-2">{labels.users_total[lang]}</div>
                        <div className="text-center text-sm text-purple-700 ml-2">
                          {formatNumber(json_data.users_total)}
                        </div>
                      </div>
                    </div>
                    <div className="bg-green-100 bg-opacity-50 rounded-md shadow-md border-1 border-pink-300">
                      <div className="text-base items-center">
                        <div className="ml-2">{labels.orders_total[lang]}</div>
                        <div className="text-center text-sm text-pink-700 ml-1">
                          {formatNumber(json_data.orders_total)}&nbsp;{labels.orders_unit[lang]}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-green-100 bg-opacity-50 rounded-md shadow-md border-1 border-purple-300">
                      <div className="text-base items-center">
                        <div className="ml-2">{labels.total_nap_sum[lang]}</div>
                        <div className="text-center text-sm text-purple-700 ml-2">
                          {formatNumber(json_data.total_nap_sum)}&nbsp;{labels.nap_unit[lang]}
                        </div>
                      </div>
                    </div>
                    <div className="bg-green-100 bg-opacity-50 rounded-md shadow-md border-1 border-pink-300">
                      <div className="text-base items-center">
                        <div className="ml-2">{labels.count_orders_today[lang]}</div>
                        <div className="text-center text-sm text-pink-700 ml-2">
                          {formatNumber(json_data.count_orders_today)}&nbsp;{labels.cup_unit[lang]}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-xs text-center items-center">
                  {labels.footer[lang]}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Admin_home;
